<template>
    <section>
        <div class="join_section1" style="position: relative;">
            <div class="con_wrap" style="display: flex; flex-direction: column; align-items: flex-start; justify-content: flex-end; padding-top: 210px; padding-bottom: 208px;">
                <p data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="font-size: 50px; font-weight: 300; text-align: left; margin-bottom: 45px;">
                    에듀테크 시장을 함께 선도해나갈<br>
                    동료를 찾습니다.
                </p>
                <div style="height: 748px; margin-bottom: 107px;">
                    <img src="@/assets/images/main_v2/background_section5.svg" alt="" style="width: 100%;">
                </div>
                <div data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-anchor-placement="center-bottom"
                    data-aos-easing="ease-in-out" style="display: flex;">
                    <p style="font-size: 24px; font-weight: 400; color: #5A5A5A; text-align: left; margin-right: 17px">
                        우리는 함께 일하면서 서로 생각<br>
                        하는 바를 끊임없이 나누고 우리<br>
                        의 서비스를 더 좋은 방향으로 발<br>
                        전시키기 위해 더 좋은 아이디어
                    </p>
                    <p style="font-size: 24px; font-weight: 400; color: #5A5A5A; text-align: left;">
                        와 의견을 가감없이 말할 수 있는<br>
                        동료들을 찾고 있습니다. 아무리<br>
                        사소할지라도 우리는 그 아이디<br>
                        어를 진지하게 받아들일겁니다.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon
    }
    
}
</script>
<style>
    .join_section1 {
        width: 100vw;
        object-fit: inherit;
    }
</style>